import constants from './constants';

const initState = {
  telemetrySuccess: false,
  telemetryLoading: false,
  telemetryError: null,

  fullVehicles: null,
  fullVehiclesLoading: false,
  fullVehiclesError: null,
};

function vehiclesReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.VEHICLES_TELEMETRY_LOADING:
      return {
        ...state,
        telemetryLoading: true,
        telemetryError: null,
      };

    case constants.VEHICLES_TELEMETRY_ERROR:
      return {
        ...state,
        telemetryError: payload,
        telemetryLoading: false,
        telemetrySuccess: false,
      };

    case constants.VEHICLES_TELEMETRY_SUCCESS:
      return {
        ...state,
        telemetrySuccess: true,
        telemetryLoading: false,
        telemetryError: null,
      };

    case constants.VEHICLES_FULL_VEHICLES_LOADING:
      return {
        ...state,
        fullVehiclesLoading: true,
        fullVehiclesError: null,
      };

    case constants.VEHICLES_FULL_VEHICLES_ERROR:
      return {
        ...state,
        fullVehiclesLoading: false,
        fullVehiclesError: payload,
      };

    case constants.VEHICLES_FULL_VEHICLES_SUCCESS:
      return {
        ...state,
        fullVehicles: payload,
        fullVehiclesLoading: false,
        fullVehiclesError: null,
      };

    default:
      return state;

  }

}

export default vehiclesReducer;
